import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Modal from "react-awesome-modal";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ReactDragList from "react-drag-list";
import ScrollBars from "react-custom-scrollbars";
import { Colors } from "./ColorSchemes/colorschemes";
import Navbar from "../../../components/CustomNav/CustomNav.Component";

import { PROXIED_MEDIABASE } from "../../../common/constants";

import {
  Body,
  Container,
  BuilderContainer,
  ScreensList,
  Row,
  InputWrapper,
  DnDContainer,
  Button,
  Header,
  ScreenListItem,
  NextButton,
  StyledForm,
  StyledSelect,
  StyledOption,
  FabButton,
  InteractionListItem,
  LessonInfo,
} from "./LessonBuilder.styles";
import {
  ModalContent,
  ModalRow,
  AssetItem,
  ModalButton,
  VideosContainer,
} from "../../../components/Admin/LessonBuilder/EditModal/Modal.styles";
import SingleRow from "../../../components/Admin/LessonBuilder/SIngleRow/SingleRow.Component";
import AddHandle from "../../../components/Admin/LessonBuilder/AddHandle/AddHandle.Component";
import LessonPreviewComponent from "./LessonPreview/LessonPreview.Component";
import AssetCollectionOption from "../../../components/Admin/LessonBuilder/AssetCollections/AssetCollectionOption";
import withServices from "../../../HOCs/withServices";
import { toast, ToastContainer } from "react-toastify";

import delIcon from "../../../assets/images/lessonbuilder/trash.svg";
import viewIcon from "../../../assets/images/lessonbuilder/preview.svg";
import Loader from "react-loader";
// import { data } from '../../sampledata';

class LessonBuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      previewOpen: false,
      toLogin: false,
      newScreenType: 0,
      newScreenName: "",
      chosenInteraction: null,
      chosenVideo: null,
      currentActiveScreen: 0,
      currentScreenIdx: 0, // use for individual screen preview
      previewScreenIdx: 0, // use for full lesson preview
      screenSaved: false,
      newScreenSaved: false, // removes duplicate screen saving issue
      screenID: null,

      currentScreen: null,
      newScreen: {},
      newScreens: [],

      // screen data
      bgColor: "#bdbdbd",
      rows: {},
      rowOrder: [],
      totalRowsCreated: [],
      nextButton: "next",
      // imageAssets: [],
      videoAssets: [],
      videoAssetsLoaded: false,
      screens: [],
      interactions: [],
      lesson: {},
      lessoninfoLoaded: false,
      lessonName: "",
      lessonDescription: "",
      assetCollections: null,
      collectionsLoaded: false,
      searchKey: "",
      videoModalOpen: false,
      vimeoModalOpen: false,
      collectionKeyword: "",
      selectedCollection: null,
      descriptionOpen: false,
      uploadImagesModal: false,
      downloadFileModal: false,
      downloadableFiles: [],
      showUploadBtn: true,
    };
    this.saveScreen = this.saveScreen.bind(this);
    this.deleteScreen = this.deleteScreen.bind(this);
    this.dragComplete = this.dragComplete.bind(this);
    this.renderScreensList = this.renderScreensList.bind(this);
    this.loadNextScreen = this.loadNextScreen.bind(this);
    this.previewOneScreen = this.previewOneScreen.bind(this);
    this.updateLessonInfo = this.updateLessonInfo.bind(this);
    this.fetchAssetCollections = this.fetchAssetCollections.bind(this);
    this.onAssetCollectionHandler = this.onAssetCollectionHandler.bind(this);
    this.uploadImages = this.uploadImages.bind(this);
    this.uploadDownloadableFile = this.uploadDownloadableFile.bind(this);
  }

  async componentDidMount() {
    const {
      match,
      services: { isUserLoggedIn, adminAPI, currentUserID },
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }
    const {
      params: { lessonId: lessonID },
    } = match;

    const [lessonRes, videoRes, interactionSets, screenRes, pdfRes] =
      await Promise.all([
        adminAPI.getSingleItemGeneral("lessons", lessonID),
        adminAPI.getVideoAssets(),
        adminAPI.getInteractionSets(),
        adminAPI.getLessonScreensInteractionsAnonymous(lessonID, 1),
        adminAPI.getLessonDownloadableFile(lessonID),
      ]);

    if (videoRes.ok) {
      const lesson = lessonRes.data;
      const interactions = interactionSets.data;
      const screens = screenRes.data.screens;
      const downloadableFiles = pdfRes.data.pdfs;
      // console.log(`all fetched screens: ` + JSON.stringify(screens, null, 2));
      let currentScreen = {};
      let bgColor = "#9d5c51";
      let rows = {};
      let rowOrder = [];
      let totalRowsCreated = [];
      let screenID = null;
      let cur = { ...screens[0] };
      let assetCollections = null;
      let collectionsLoaded = false;

      if (screens.length) {
        cur = { ...screens[0] };
        bgColor = cur.DisplayData ? cur.DisplayData.background : "#bdbdbd";
        screenID = cur.LessonScreenId;

        if (cur.ScreenType === 0) {
          rows = cur.DisplayData.rows;
          rowOrder = cur.DisplayData.rowOrder;
          totalRowsCreated = cur.DisplayData.totalRowsCreated;
          currentScreen = { ...cur };
        }
        if (cur.ScreenType === 1) {
          if (cur.interaction_url !== null) {
            const interactionInfo =
              await this.props.services.adminAPI.getInteractionFromUrl(
                cur.interaction_url.replace("/api/v1/", "")
              );
            if (interactionInfo.ok) {
              // console.log(
              //   `LoadedInteraction: ${JSON.stringify(interactionInfo.data)}`
              // );
              const newScreen = {
                // DisplayData: { ...cur.DisplayData },
                ...cur,
                ...interactionInfo.data,
                // ScreenType: cur.ScreenType,
              };
              currentScreen = { ...newScreen };
            } else {
              toast.error("Interaction Could Not Be Fetched");
            }
          } else {
            currentScreen = {
              DisplayData: { ...cur.DisplayData, ScreenType: cur.ScreenType },
            };
          }
        }
        if (cur.ScreenType === 2 || cur.ScreenType === 4) {
          const res = await adminAPI.getAssetCollections();
          if (res.ok) {
            // console.log("AssetCollections: " + JSON.stringify(res.data));
            assetCollections = res.data;
            collectionsLoaded = true;
          }
          currentScreen = { ...cur };
        }
      }

      const newScreen = {
        Title: "",
        Lesson: lessonID,
        ScreenType: 0,
        User: currentUserID,
        DisplayData: {},
        DisplayOrder: null,
        InteractionSet: null,
        VideoUrl: "",
      };
      this.setState({
        lesson,
        lessonName: lesson.Name,
        lessonDescription: lesson.Description,
        lessoninfoLoaded: true,
        screens,
        interactions,
        assetCollections,
        collectionsLoaded,
        newScreen,
        currentScreen,
        bgColor,
        screenID,
        rows,
        rowOrder,
        totalRowsCreated,
        screenSaved: true,
        newScreen,
        newScreenName: cur.Title,
        downloadableFiles,
      });
    } else {
      toast.error("Error fetching Lesson details!");
    }
  }

  async onAssetCollectionHandler(screenType, event) {
    this.setState({ selectedCollection: +event.target.value });
    const collectionID = event.target.value;
    const {
      services: { adminAPI },
    } = this.props;
    if (screenType === 2) {
      // video
      const res = await adminAPI.getCollectionVideoItems(collectionID);
      if (res.ok) {
        const videoRes = res.data.assets;
        toast.warn(
          videoRes.length > 0
            ? `This collection has ${videoRes.length} Videos`
            : `This Collection has no Videos`
        );
        this.setState({ videoAssets: videoRes, videoAssetsLoaded: true });
      }
    }
    if (screenType === 4) {
      // vimeo
      const res = await adminAPI.getCollectionVimeoItems(collectionID);
      if (res.ok) {
        const videoRes = res.data.assets;
        toast.warn(
          videoRes.length > 0
            ? `This collection has ${videoRes.length} Vimeo Items`
            : `This Collection has no Vimeo Items`
        );
        this.setState({ videoAssets: videoRes, videoAssetsLoaded: true });
      }
    }
  }

  onLogout = () => {
    this.setState({ toLogin: true });
  };
  onGoBack = () => {
    this.props.history.goBack();
  };
  closeVideoModal = () => {
    this.setState({ videoModalOpen: false });
  };
  closeVimeoModal = () => {
    this.setState({ vimeoModalOpen: false });
  };
  toggleDescriptionModal = () => {
    const { descriptionOpen } = this.state;
    this.setState({ descriptionOpen: !descriptionOpen });
  };
  openVideoModal = (field) => {
    if (field === "video") {
      this.setState({ videoModalOpen: true });
    }
    if (field === "vimeo") {
      this.setState({ vimeoModalOpen: true });
    }
  };
  addRow = (type, level) => {
    // for assets, create a row then add the asset in 1 column
    const { rowOrder, rows, totalRowsCreated } = this.state;
    const newId = `row-${totalRowsCreated.length}`;
    const order = Array.from(rowOrder);
    const totalRows = Array.from(totalRowsCreated); // added to ensure all generated rows have unique IDs
    let assets = [];

    if (type === "2col") {
      assets = [null, null];
    }

    if (type === "3col") {
      assets = [null, null, null];
    }

    if (type === "4col") {
      assets = [null, null, null, null];
    }

    if (type === "icon" || type === "image" || type === "video") {
      const name = "asset-1";
      const formatted = {
        id: name,
        type,
        content: "",
        size: "auto",
        align: "center",
      };

      assets.push(formatted);
    }

    if (type === "text") {
      const name = "asset-1";
      const formatted = {
        id: name,
        type,
        content: "Enter Text",
        size: 20,
        align: "center",
      };

      assets.push(formatted);
    }

    const rowData = {
      id: `row-${rowOrder.length}`,
      assets,
    };

    const newRows = { ...rows };
    newRows[newId] = rowData;

    order.push(`row-${totalRows.length}`);
    totalRows.push(`row-${totalRows.length}`);
    const newState = {
      ...this.state,
      rowOrder: order,
      rows: newRows,
      totalRowsCreated: totalRows,
    };

    this.setState(newState);
  };

  addAsset = (type, level, columnIndex, rowId) => {
    const { rows } = this.state;

    const allRows = { ...rows };

    const currentRow = allRows[rowId];
    const curAssets = currentRow.assets;

    const name = `asset-${columnIndex}`;
    let formatted = null;
    if (type === "icon" || type === "image" || type === "video") {
      formatted = {
        id: name,
        type,
        content: "",
        size: "auto",
        align: "center",
      };
    }

    if (type === "text") {
      formatted = {
        id: name,
        type,
        content: "Enter Text",
        size: 20,
        align: "center",
      };
    }
    curAssets.splice(columnIndex, 1, formatted);

    const newState = {
      ...this.state,
      rows: allRows,
    };
    this.setState(newState);
  };

  changeStyleProps = (columnIndex, property, value, rowId) => {
    const { rows } = this.state;
    const allRows = { ...rows };

    const currentRow = allRows[rowId];
    const currentAssets = currentRow.assets;

    let formatted = null;

    if (property === "size") {
      formatted = {
        ...currentAssets[columnIndex],
        size: value,
      };
    }
    if (property === "align") {
      formatted = {
        ...currentAssets[columnIndex],
        align: value,
      };
    }

    currentAssets.splice(columnIndex, 1, formatted);
    const newState = {
      ...this.state,
      rows: allRows,
    };
    this.setState(newState);
  };

  editAsset = (columnIndex, rowId, value) => {
    const { rows } = this.state;
    const allRows = { ...rows };

    const currentRow = allRows[rowId];
    const currentAssets = currentRow.assets;
    const formatted = {
      ...currentAssets[columnIndex],
      content: value,
    };
    currentAssets.splice(columnIndex, 1, formatted);
    const newState = {
      ...this.state,
      rows: allRows,
    };
    this.setState(newState);
  };

  deleteAsset = (columnIndex, rowId) => {
    const { rows } = this.state;
    const allRows = { ...rows };
    const currentRow = allRows[rowId];
    const assets = currentRow.assets;
    assets.splice(columnIndex, 1, null);

    const newState = {
      ...this.state,
      rows: allRows,
    };

    this.setState(newState);
  };

  deleteRow = (rowId) => {
    const { rows, rowOrder, totalRowsCreated } = this.state;
    const allRows = { ...rows };
    const order = Array.from(rowOrder);
    const totalRows = Array.from(totalRowsCreated);

    // delete selected row
    delete allRows[rowId];
    const idx = order.indexOf(rowId);
    order.splice(idx, 1);

    if (order.length === 0) {
      totalRows.splice(0);
    }

    const newState = {
      ...this.state,
      rows: allRows,
      rowOrder: order,
      totalRowsCreated: totalRows,
    };
    this.setState(newState);
  };

  onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    } // item dropped outside a droppable area

    if (destination.index === source.index) {
      return;
    } // item droped in its original position

    const { rowOrder } = this.state;
    const rows = Array.from(rowOrder);

    rows.splice(source.index, 1); // remove 1 row from the source index

    rows.splice(destination.index, 0, result.draggableId); // add dragged row at destination index

    // const newState = {
    //     ...this.state,
    //     rowOrder: rows
    // }

    this.setState({ rowOrder: rows });
    // ideally this new state is the lesson screen, push to backend
    // you may want to add color info etc
  };

  toggleImagesUploadModal = () => {
    const { uploadImagesModal } = this.state;
    this.setState({ uploadImagesModal: !uploadImagesModal });
  };

  addNewScreen = () => {
    const { screens, bgColor, currentActiveScreen, newScreens } = this.state;

    const allScreens = Array.from(newScreens);

    // push a screen with minimum details into the screen array for rendering the screen list
    // requires Title, Display Data containg bgColor
    // this screen is not saved and will be saved in the saveScreen method
    const newScreen = {
      Title: "New Screen",
      DisplayData: {
        background: bgColor,
      },
      // DisplayOrder: screens.length
    };

    allScreens.push(newScreen);
    this.setState({
      newScreens: allScreens,
      currentScreen: newScreen,
      nextButton: "next",
      newScreenType: 0,
      rows: {},
      rowOrder: [],
      totalRowsCreated: [],
      chosenVideo: null,
      chosenInteraction: null,
      screenSaved: false,
      newScreenSaved: false,
    });
  };

  async saveScreen(event) {
    event.preventDefault();
    const {
      rows,
      rowOrder,
      totalRowsCreated,
      screens,
      newScreen,
      chosenInteraction,
      chosenVideo,
      newScreenName,
      newScreenType,
      bgColor,
      nextButton,
      screenSaved,
      newScreenSaved,
      screenID,
      currentScreen,
    } = this.state;

    const {
      services: { adminAPI },
      match,
    } = this.props;
    const {
      params: { lessonId: lessonID },
    } = match;

    let DisplayData = {
      background: bgColor,
      nextButton,
    };
    // new screen
    const screenData = {
      ...newScreen,
      Title: newScreenName,
      ScreenType: newScreenType,
      DisplayData,
      InteractionSet: null,
      DisplayOrder: screens.length,
      VideoUrl: "",
    };

    let screen = { ...screenData };

    if (newScreenType === 0) {
      DisplayData.rows = rows;
      DisplayData.rowOrder = rowOrder;
      DisplayData.totalRowsCreated = totalRowsCreated;
    }
    if (newScreenType === 1) {
      screen.InteractionSet = chosenInteraction;
    }

    if (newScreenType === 2 || newScreenType === 3 || newScreenType === 4) {
      screen.VideoUrl = chosenVideo;
    }
    // existing screen to be updated

    if (screenSaved) {
      const item = {
        ...screen,
        DisplayOrder: currentScreen.DisplayOrder,
      };
      const res = await adminAPI.updateScreenPartial(item, screenID);
      if (res.ok) {
        const screenResponse =
          await adminAPI.getLessonScreensInteractionsAnonymous(lessonID, 1);
        toast.success("Screen Updated!");
        if (screenResponse.ok) {
          const screensRes = screenResponse.data.screens;
          // console.log("ScreensAfterSave: " + JSON.stringify(screens, null, 2));
          const unsavedScreens = this.state.newScreens; // clear on success
          unsavedScreens.splice(0);
          this.setState({ screens: screensRes, newScreens: unsavedScreens });
          return;
        } else {
          toast.warn(
            "Failed to fetch screens after saving, Refresh your browser"
          );
        }
      } else {
        toast.error("Screen not updated");
      }
    } else {
      const res = await adminAPI.createItemGeneral("lesson_screens", screen);
      if (res.ok) {
        const screenResponse =
          await adminAPI.getLessonScreensInteractionsAnonymous(lessonID, 1);
        toast.success("Screen Saved!");
        if (screenResponse.ok) {
          const screensRes = screenResponse.data.screens;
          const unsavedScreens = this.state.newScreens; // clear on success
          unsavedScreens.splice(0);
          this.setState({
            ...this.state,
            screens: screensRes,
            newScreens: unsavedScreens,
            screenSaved: true,
            currentScreen: screensRes[screensRes.length - 1],
          });
          // this.setState({ newScreenSaved: true,  });
          window.location.reload();
        } else {
          toast.warn(
            "Failed to fetch screens after saving, Refresh your browser"
          );
        }
      } else {
        toast.error("Screen not saved!");
      }
    }
  }

  async deleteScreen(screenID) {
    const retVal = confirm(
      "Are you sure you want to delete this screen?" + screenID
    );
    const {
      services: { adminAPI },
      match,
    } = this.props;
    const {
      params: { lessonId: lessonID },
    } = match;
    if (retVal) {
      const res = await adminAPI.deleteItemGeneral("lesson_screens", screenID);

      if (res.ok) {
        toast.success("Screen Deleted!");
        const screenRes = await adminAPI.getLessonScreensInteractionsAnonymous(
          lessonID,
          1
        );

        if (screenRes.ok) {
          const newScreens = screenRes.data.screens;
          this.setState({ screens: newScreens, screenSaved: false });
          // this.forceUpdate();
          // window.location.reload();
        }
      } else {
        toast.error("Failed to delete, try again!");
      }
      return true;
    } else {
      toast.info("Delete Canceled!");
      return false;
    }
  }

  async dragComplete() {
    const { screens } = this.state;
    const {
      services: { adminAPI },
      match,
    } = this.props;
    const {
      params: { lessonId: lessonID },
    } = match;
    // console.log("ScreensAfterDrag: " + JSON.stringify(screens, null, 2));

    const formattedScreens = screens.map((screen) => {
      const formattedScreen = { id: screen.LessonScreenId, ...screen };
      delete formattedScreen.LessonScreenId;
      return formattedScreen;
    });

    const item = {
      DisplayItems: JSON.stringify(formattedScreens),
    };
    const res = await adminAPI.updateLessonScreenOrder(item);

    if (res.ok) {
      toast.success("Screen Order Updated");
      const screenRes = await adminAPI.getLessonScreensInteractionsAnonymous(
        lessonID,
        1
      );

      if (screenRes.ok) {
        const updatedScreens = screenRes.data.screens;
        this.setState({ screens: updatedScreens });
        window.location.reload();
      }
    } else {
      toast.error("Failed! Screen Order Not Changed!");
    }
  }

  handleScreenItemClick = (id) => {
    const { screens, currentScreenIdx, newScreens, bgColor } = this.state;

    if (screens.length) {
      // screen exists
      const currentScreen = { ...screens[id] };

      const newIdx = id;
      // const bgColor = currentScreen.DisplayData.background;
      const screenType = currentScreen.ScreenType;
      const screenID = currentScreen.LessonScreenId;
      const screenName = currentScreen.Title;
      let currentRows = {};
      let currentRowOrder = [];
      let currentTotalRowsCreated = [];

      if (screenType === 0) {
        currentRows = currentScreen.DisplayData.rows;
        currentRowOrder = currentScreen.DisplayData.rowOrder;
        currentTotalRowsCreated = currentScreen.DisplayData.totalRowsCreated;
      }

      if (screenType === 2 || screenType === 4) {
        this.fetchAssetCollections();
      }
      document.getElementById("screen-details").reset();
      this.setState({
        // newScreens: unsavedScreens,
        currentScreen,
        screenID,
        currentScreenIdx: newIdx,
        newScreenType: screenType,
        newScreenName: screenName,
        bgColor,
        screenSaved: true,
        newScreenSaved: false,
        rows: currentRows,
        rowOrder: currentRowOrder,
        totalRowsCreated: currentTotalRowsCreated,
        chosenInteraction: currentScreen.InteractionSet,
        chosenVideo: currentScreen.VideoUrl,
        searchKey: "",
        videoAssets: [],
      });
    } else {
      toast.warn("Try Again!");
    }
  };

  async previewOneScreen(id) {
    const { screens } = this.state;
    const cur = screens[id];
    let newScreen = cur;
    if (cur.ScreenType === 1) {
      // load interaction info
      const interactionInfo =
        await this.props.services.adminAPI.getInteractionFromUrl(
          cur.interaction_url.replace("/api/v1/", "")
        );
      if (interactionInfo.ok) {
        newScreen = {
          DisplayData: { ...cur.DisplayData },
          ...interactionInfo.data,
          ScreenType: cur.ScreenType,
        };
        // this.setState({ currentScreen: newScreen });
      } else {
        toast.error("Interaction Could Not Be Fetched");
      }
    }
    this.setState({
      currentScreen: newScreen,
      previewOpen: true,
      currentScreenIdx: id,
    });
  }
  onSearchChange = (field, e) => {
    if (field === "interaction") {
      this.setState({ searchKey: e.target.value });
    }
    if (field === "asset") {
      this.setState({ searchKey: e.target.value });
    }
    if (field === "collection") {
      this.setState({ collectionKeyword: e.target.value });
    }
  };

  changeColorHandler = (event) => {
    this.setState({ bgColor: event.target.value });
  };

  async fetchAssetCollections() {
    const {
      services: { adminAPI },
    } = this.props;
    const res = await adminAPI.getAssetCollections();
    if (res.ok) {
      this.setState({ collectionsLoaded: true, assetCollections: res.data });
    }
  }

  chooseScreenType = (event) => {
    const screenid = +event.target.value;
    if (screenid === 2 || screenid === 4) {
      this.fetchAssetCollections();
    }
    this.setState({ newScreenType: screenid });
  };

  changeNextButtonText = (event) => {
    const val = event.target.value;
    this.setState({ nextButton: val });
  };
  changeScreenName = (event) => {
    this.setState({ newScreenName: event.target.value });
  };
  openModal = () => {
    const { screens } = this.state;
    let currentScreen;
    if (screens.length) {
      currentScreen = screens[0];
    }
    this.setState({ previewOpen: true, currentScreen });
  };
  closeModal = () => {
    this.setState({ previewOpen: false });
  };
  async loadNextScreen() {
    const { currentScreenIdx, screens, previewScreenIdx } = this.state;
    const idx = previewScreenIdx + 1;
    let newScreen;
    if (screens.length && idx < screens.length) {
      const cur = screens[idx]; // next screen
      if (cur.ScreenType === 1) {
        // load interaction info
        const interactionInfo =
          await this.props.services.adminAPI.getInteractionFromUrl(
            cur.interaction_url.replace("/api/v1/", "")
          );
        if (interactionInfo.ok) {
          newScreen = {
            DisplayData: { ...cur.DisplayData },
            ...interactionInfo.data,
            ScreenType: cur.ScreenType,
          };
          this.setState({ previewScreenIdx: idx, currentScreen: newScreen });
        } else {
          toast.error("Interaction Could Not Be Fetched");
        }
      } else {
        newScreen = { ...cur };
        this.setState({ previewScreenIdx: idx, currentScreen: newScreen });
      }
      // console.log(`CurrentScreenInLoader: ${JSON.stringify(newScreen)}`);
      // this.setState({currentScreenIdx: idx, currentScreen: newScreen});
    } else {
      this.setState({ previewScreenIdx: 0, previewOpen: false });
    }
  }

  chooseInteractionSet = (id) => {
    this.setState({ chosenInteraction: id });
  };

  chooseVideoAsset = (fileName, e) => {
    this.setState({ chosenVideo: fileName, videoModalOpen: false });
  };
  changeLessonName = (e) => {
    this.setState({ lessonName: e.target.value });
  };
  changeLessonDescription = (e) => {
    this.setState({ lessonDescription: e.target.value });
  };
  async updateLessonInfo(e) {
    e.preventDefault();
    const { lesson, lessonName, lessonDescription } = this.state;
    const item = {
      ...lesson,
      Name: lessonName,
      Description: lessonDescription,
    };
    const res = await this.props.services.adminAPI.updateItemGeneral(
      "lessons",
      item,
      item.LessonId
    );
    if (res.ok) {
      toast.success("Update Successful");
    } else {
      toast.error("Update Failed");
    }
  }

  async uploadImages(e) {
    e.preventDefault();
    const {
      params: { lessonId: lessonID },
    } = this.props.match;
    const fileInputElement = e.target.elements.upload_images;
    const formData = new FormData();
    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadLessonImages(
      formData,
      lessonID
    );

    if (res.ok) {
      toast.success("Upload Successful");
      const screensRes =
        await this.props.services.adminAPI.getLessonScreensInteractionsAnonymous(
          lessonID,
          1
        );
      if (screensRes.ok) {
        const screens = screensRes.data.screens;
        this.setState({
          ...this.state,
          screens,
        });
      }
      window.location.reload();
    } else {
      toast.error("Upload Failed");
    }
  }

  async uploadDownloadableFile(e) {
    e.preventDefault();
    this.setState({ showUploadBtn: false });

    const {
      params: { lessonId: lessonID },
    } = this.props.match;

    const el = e.target.elements.upload_downloadable;

    const formData = new FormData();

    for (const i of el.files) {
      formData.append("files", i);
    }

    formData.append("lesson_id", lessonID);

    const res = await this.props.services.adminAPI.uploadLessonDownloadableFile(
      formData
    );

    if (res.ok) {
      toast.success("Upload Successful");
      this.setState({ showUploadBtn: true });
      window.location.reload();
    } else {
      toast.error("Upload Failed");
      this.setState({ showUploadBtn: true });
    }
  }

  renderPreviewModal = () => {
    const { currentScreen } = this.state;

    if (currentScreen !== null) {
      // console.log("CurrentScreenInPreview: " + JSON.stringify(currentScreen, null, 2));
      return (
        <Modal
          visible={this.state.previewOpen}
          style={{ zIndex: "1000000 !important" }}
          width="80%"
          height="100%"
          effect="fadeInUp"
          onClickAway={this.closeModal}
        >
          <ModalContent>
            <LessonPreviewComponent
              screen={currentScreen}
              closeModal={this.closeModal}
              loadNext={this.loadNextScreen}
            />
            <ModalButton onClick={this.closeModal}>Done</ModalButton>
          </ModalContent>
        </Modal>
      );
    } else {
      return <Loader color="#3ee9f700" />;
    }
  };

  renderScreensList = () => {
    const { screens, bgColor } = this.state;
    // console.log("Screendat " + JSON.stringify(screens))
    if (screens.length && typeof screens !== "undefined") {
      return (
        <ReactDragList
          dataSource={screens}
          rowKey="id"
          row={(screen, idx) => (
            <ScreenListItem
              key={`screen-item-${idx}`}
              bgColor={
                screen.DisplayData ? screen.DisplayData.background : bgColor
              }
              onClick={this.handleScreenItemClick.bind(this, idx)}
            >
              <p>{screen.Title}</p>
              <div>
                <img
                  src={viewIcon}
                  height="20px"
                  onClick={this.previewOneScreen.bind(this, idx)}
                />
                <img
                  src={delIcon}
                  onClick={this.deleteScreen.bind(this, screen.LessonScreenId)}
                />
              </div>
            </ScreenListItem>
          )}
          handles={false}
          className="simple-drag"
          rowClassName="simple-drag-row"
          onUpdate={this.dragComplete}
        ></ReactDragList>
      );
    } else {
      return <Loader color="#acff24" />;
    }
  };

  renderUnsavedScreensList = () => {
    const { newScreens } = this.state;
    if (newScreens.length) {
      return newScreens.map((screen, idx) => {
        return (
          <ScreenListItem
            key={`new-screen-${idx}`}
            bgColor={
              screen.DisplayData ? screen.DisplayData.background : bgColor
            }
            onClick={this.handleScreenItemClick.bind(this, idx)}
          >
            <p>{screen.Title}</p>
            {/* <div>
                        <img src={viewIcon} height="20px" onClick={this.previewOneScreen.bind(this, idx)} />
                        <img src={delIcon} onClick={this.deleteScreen.bind(this, screen.LessonScreenId)} />
                    </div> */}
          </ScreenListItem>
        );
      });
    }
  };
  renderCollectionOptions = (screenType) => {
    const {
      collectionsLoaded,
      assetCollections,
      selectedCollection,
      collectionKeyword,
    } = this.state;
    if (collectionsLoaded) {
      const filteredCollections = assetCollections.filter((item) => {
        if (collectionKeyword === "") {
          return item;
        } else {
          return item.Name.toLowerCase().includes(
            collectionKeyword.toLowerCase()
          );
        }
      });
      return (
        <React.Fragment>
          {/* <p style={{ color: "white" }}>Choose A Collection Here!</p> */}
          <input
            type="text"
            className="custom-textfield"
            placeholder="Search Collection Name"
            value={collectionKeyword}
            onChange={this.onSearchChange.bind(this, "collection")}
          />
          <ScrollBars style={{ height: "70vh" }} className="hide-x">
            {filteredCollections.map((collection) => {
              return (
                <AssetCollectionOption
                  collectionID={collection.AssetCollectionId}
                  selectedCollection={selectedCollection}
                  collectionName={collection.Name}
                  collectionDescription={collection.Description}
                  onCollectionChange={this.onAssetCollectionHandler.bind(
                    this,
                    screenType
                  )}
                />
              );
            })}
          </ScrollBars>
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff2430" />;
    }
  };
  renderVideosContainer = (type) => {
    const { videoAssets, videoAssetsLoaded, searchKey } = this.state;
    if (videoAssetsLoaded) {
      const filteredVideos = videoAssets.filter((item) => {
        if (searchKey === "") {
          return item;
        } else {
          return item.Title.toLowerCase().includes(searchKey.toLowerCase());
        }
      });
      return (
        <React.Fragment>
          {/* <p style={{ color: "white" }}>Choose An Image Here!</p> */}
          <input
            style={{ width: "75%" }}
            type="text"
            className="custom-textfield"
            placeholder="Search Asset Name"
            value={this.state.searchKey}
            onChange={this.onSearchChange.bind(this, "asset")}
          />
          <VideosContainer>
            {filteredVideos.map((vid, idx) => {
              return (
                <AssetItem border={true}>
                  {type === 2 ? (
                    <video
                      key={idx}
                      width="200"
                      height="auto"
                      src={`${PROXIED_MEDIABASE}assets/${vid.FileName}`}
                    />
                  ) : (
                    <VideoPlayer videoId={vid.FileName} width="200px" />
                  )}
                  <p className="col-asset-name">{vid.Title}</p>
                  <button
                    onClick={this.chooseVideoAsset.bind(this, vid.FileName)}
                    className="add-vimeo"
                  >
                    Add Video
                  </button>
                </AssetItem>
              );
            })}
          </VideosContainer>
        </React.Fragment>
      );
    } else {
      return (
        <VideosContainer>
          <p
            style={{
              color: "#fff",
              font: "italic bold 26px 'Roboto",
              marginTop: "35%",
              textAlign: "center",
            }}
          >
            Please choose a Video Collection First
          </p>
        </VideosContainer>
      );
    }
  };

  renderContentBuilder = () => {
    const { rows, rowOrder, currentScreen } = this.state;
    return (
      <React.Fragment>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="container-1">
            {(provided) => (
              <DnDContainer
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {rowOrder.map((rowId, idx) => {
                  const row = rows[rowId];
                  const assets = row.assets;

                  return (
                    <SingleRow
                      key={currentScreen.LessonScreenId + idx}
                      rowId={rowId}
                      assets={assets}
                      index={idx}
                      addAsset={this.addAsset}
                      editAsset={this.editAsset}
                      changeStyleProperty={this.changeStyleProps}
                      deleteAsset={this.deleteAsset}
                      deleteRow={this.deleteRow}

                      // images={this.state.imageAssets}
                      // videos={this.state.videoAssets}
                    />
                  );
                })}
                {provided.placeholder}
              </DnDContainer>
            )}
          </Droppable>
        </DragDropContext>
        <AddHandle level="row" clickAdd={this.addRow} />
      </React.Fragment>
    );
  };

  renderVideoBuilder = () => {
    const { videoAssets, currentScreen, collectionsLoaded, videoAssetsLoaded } =
      this.state;
    if (collectionsLoaded) {
      return (
        <React.Fragment>
          <Modal
            visible={this.state.videoModalOpen}
            width="90%"
            height="85%"
            effect="fadeInUp"
            onClickAway={() => this.closeVideoModal()}
          >
            <ModalContent>
              <ModalRow>
                <div className="modal-left">
                  {this.renderCollectionOptions(2)}
                </div>
                <div className="modal-right">
                  {this.renderVideosContainer(2)}
                </div>
              </ModalRow>
            </ModalContent>
          </Modal>

          {currentScreen !== null ? (
            <video
              width="400"
              height="auto"
              src={`${PROXIED_MEDIABASE}assets/${currentScreen.VideoUrl}`}
            />
          ) : (
            ""
          )}
          <Button onClick={this.openVideoModal.bind(this, "video")}>
            Pick a Video
          </Button>
        </React.Fragment>
      );
    } else {
      toast.info("Fetching Collections!");
      return <Loader color="#3ee9f7" />;
    }
  };
  renderVimeoBuilder = () => {
    const {
      videoAssets,
      currentScreen,
      assetCollections,
      collectionsLoaded,
      videoAssetsLoaded,
    } = this.state;
    console.log({ currentScreen });
    if (collectionsLoaded) {
      return (
        <React.Fragment>
          <Modal
            visible={this.state.videoModalOpen}
            width="90%"
            height="85%"
            effect="fadeInUp"
            onClickAway={() => this.closeVideoModal()}
          >
            <ModalContent>
              <ModalRow>
                <div className="modal-left">
                  {this.renderCollectionOptions(4)}
                </div>
                <div className="modal-right">
                  {this.renderVideosContainer(4)}
                </div>
              </ModalRow>
            </ModalContent>
          </Modal>
          {currentScreen !== null ? (
            <VideoPlayer
              videoId={currentScreen.VideoUrl}
              width="540px"
              height="480px"
            />
          ) : (
            ""
          )}
          <Button onClick={this.openVideoModal.bind(this, "video")}>
            Pick a Video
          </Button>
        </React.Fragment>
      );
    } else {
      toast.info("Fetching Collections!");
      return <Loader color="#3ee9f7" />;
    }
  };

  renderInteractionsBuilder = (currentScreen) => {
    const { interactions, searchKey, chosenInteraction } = this.state;
    if (interactions.length) {
      const filteredInteractions = interactions.filter((item) => {
        return `${item.id} ${item.name}`
          .toLowerCase()
          .includes(searchKey.toLowerCase());
      });
      return (
        <React.Fragment>
          <p>
            Current Interaction:{" "}
            {currentScreen === null || currentScreen.InteractionSet === null
              ? "No Interaction Selected"
              : currentScreen.InteractionSet}
          </p>
          <Row>
            <div style={{ width: "100%" }}>
              <input
                type="text"
                value={searchKey}
                placeholder="Search for an interaction"
                className="custom-textfield lb-select"
                onChange={this.onSearchChange.bind(this, "interaction")}
              />
              <ScrollBars className="hide-x" style={{ height: "500px" }}>
                {filteredInteractions.map((interaction) => {
                  return (
                    <InteractionListItem
                      onClick={this.chooseInteractionSet.bind(
                        this,
                        interaction.id
                      )}
                      isCurrent={
                        currentScreen.InteractionSet === interaction.id
                      }
                      isChosen={chosenInteraction === interaction.id}
                      key={interaction.id}
                    >
                      <span>{interaction.id} </span> &nbsp;&nbsp;
                      {interaction.name}
                    </InteractionListItem>
                  );
                })}
              </ScrollBars>
            </div>
          </Row>
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff24" />;
    }
  };
  renderLessonInfo = () => {
    const { lesson, lessoninfoLoaded } = this.state;
    if (lessoninfoLoaded) {
      return (
        <React.Fragment>
          <LessonInfo>
            <div className="lesson-info">
              <h1 className="lesson-name">{lesson.Name}</h1>
              <p className="lesson-description">{lesson.Description}</p>
            </div>
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
              onClick={this.toggleDescriptionModal}
            />
          </LessonInfo>
          <Modal
            visible={this.state.descriptionOpen}
            width="80%"
            height="300"
            effect="fadeInUp"
            backgroundColor={this.state.bgColor}
            onClickAway={() => this.toggleDescriptionModal()}
          >
            <StyledForm
              onSubmit={this.handleLessonInfoChange}
              style={{ border: "none" }}
            >
              <BuilderContainer
                bgColor={this.state.bgColor}
                // style={{ width: "80%", marginBottom: "5em" }}
              >
                <Row>
                  <InputWrapper cols={2}>
                    <p>Lesson Name</p>
                    <textarea
                      name="title"
                      id="title"
                      cols={40}
                      rows={3}
                      className="custom-textfield lb-textfield"
                      style={{ height: "100px" }}
                      // value={this.state.lessonName}
                      data-arg="name"
                      onChange={this.changeLessonName}
                    >
                      {lesson.Name}
                    </textarea>
                  </InputWrapper>
                  <InputWrapper cols={2}>
                    <p>Description</p>
                    <textarea
                      name="title"
                      id="title"
                      cols={30}
                      rows={3}
                      className="custom-textfield lb-textfield"
                      style={{ height: "100px" }}
                      // value={this.state.lessonDescription}
                      data-arg="Description"
                      onChange={this.changeLessonDescription}
                    >
                      {lesson.Description}
                    </textarea>
                  </InputWrapper>
                </Row>
                <Button onClick={this.updateLessonInfo}>Update</Button>
              </BuilderContainer>
            </StyledForm>
          </Modal>
        </React.Fragment>
      );
    } else {
      console.log("Lesson info loading...");
      return;
    }
  };

  renderUploadImagesModal = () => {
    return (
      <Modal
        visible={this.state.uploadImagesModal}
        width="400"
        height="200"
        effect="fadeInUp"
        backgroundColor={this.state.bgColor}
        onClickAway={() => this.toggleImagesUploadModal()}
      >
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <StyledForm
          justify="center"
          bgColor="#999"
          onSubmit={(e) => this.uploadImages(e)}
        >
          <input
            type="file"
            name="upload_images"
            id="upload_images"
            multiple={true}
            accept=".png,.jpeg,.jpg"
          />
          <button
            style={{ width: "300px" }}
            className="green-button"
            type="submit"
          >
            Upload
          </button>
        </StyledForm>
      </Modal>
    );
  };

  renderDownloadableFileModal = () => {
    const { showUploadBtn } = this.state;
    return (
      <Modal
        visible={this.state.downloadFileModal}
        width="400"
        height="200"
        effect="fadeInUp"
        backgroundColor={this.state.bgColor}
        /*tslint:disable-next-line jsx-no-lambda*/
        onClickAway={() => this.setState({ downloadFileModal: false })}
      >
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <StyledForm
          justify="center"
          bgColor="#999"
          onSubmit={(e) => this.uploadDownloadableFile(e)}
        >
          <input
            type="file"
            name="upload_downloadable"
            id="upload_downloadable"
            multiple={true}
            accept=".pdf"
          />
          <button
            style={{
              width: "300px",
              display: showUploadBtn ? "inline-block" : "none",
            }}
            className="green-button"
            type="submit"
          >
            Upload File
          </button>
          <span
            style={{
              color: "var(--red)",
              display: showUploadBtn ? "none" : "inline-block",
              fontWeight: "bold",
            }}
          >
            UPLOADING...
          </span>
        </StyledForm>
      </Modal>
    );
  };

  showBuilder = (newScreenType, currentScreen) => {
    let screenType = newScreenType;
    // console.log("CurrentScreenInBuilder: " + JSON.stringify(currentScreen));
    if (
      currentScreen !== null &&
      currentScreen !== {} &&
      currentScreen.hasOwnProperty("ScreenType")
    ) {
      screenType = currentScreen.ScreenType;
    }

    if (screenType === 0) {
      return this.renderContentBuilder(currentScreen);
    }
    if (screenType === 1) {
      return this.renderInteractionsBuilder(currentScreen);
    }
    if (screenType === 2) {
      return this.renderVideoBuilder(currentScreen);
    }
    if (screenType === 4) {
      return this.renderVimeoBuilder(currentScreen);
    }
  };
  openPreview = () => {
    const { history, match } = this.props;
    const id = match.params.lessonId;

    history.push(`/admins/lessonpreview/${id}`);
  };

  render() {
    const earths = Object.entries(Colors.earths);
    const mids = Object.entries(Colors.mids);
    const allColors = earths.concat(mids);
    const { newScreenType, currentScreen, downloadableFiles } = this.state;

    // console.log(`currentscreen: ${JSON.stringify(currentScreen, null, 4)}`)

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <div
        style={{
          backgroundColor: `${this.state.bgColor}50`,
          minHeight: "100vh",
        }}
      >
        <Navbar logoutParent={this.onLogout} />
        <ToastContainer />
        <Header>
          <p
            style={{ paddingLeft: "10%", color: "#fff" }}
            className="go-back"
            onClick={this.onGoBack}
          >
            &lt; Back
          </p>
        </Header>

        <Header> {this.renderLessonInfo()}</Header>
        <Header>{this.renderUploadImagesModal()}</Header>
        {this.renderDownloadableFileModal()}
        <Body>
          {this.renderPreviewModal()}

          <Container>
            <ScreensList>
              <p
                style={{
                  textAlign: "center",
                  color: "#fff",
                  lineHeight: "1",
                  marginTop: "-4em",
                }}
              >
                Click a screen Item to edit it <br /> or <br /> Click add to
                create a New Screen
              </p>
              {this.renderScreensList()}
              {this.renderUnsavedScreensList()}
              <Button onClick={this.addNewScreen}>ADD</Button>
              <p
                style={{
                  textAlign: "center",
                  color: "#fff",
                  lineHeight: "1",
                  marginTop: "2em",
                }}
              >
                Add image(s) as screens
              </p>
              <Button onClick={this.toggleImagesUploadModal}>
                ADD IMAGE(S)
              </Button>

              <p
                style={{
                  // textAlign: "center",
                  marginTop: "40px",
                  color: "#fff",
                }}
              >
                Add Downloadable File
              </p>
              <Button
                /*tslint:disable-next-line jsx-no-lambda*/
                onClick={() => this.setState({ downloadFileModal: true })}
              >
                Upload File
              </Button>

              {downloadableFiles.length ? (
                <a
                  href={`${PROXIED_MEDIABASE}assets/${downloadableFiles[0].FileName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {downloadableFiles[0].FileName}
                </a>
              ) : (
                ""
              )}

              <Button style={{ marginTop: "40px" }} onClick={this.openPreview}>
                PREVIEW
              </Button>
              {/* <Button style={{ marginTop: '40px' }} onClick={this.loadNextScreen}>LOAD NEXT</Button> */}
            </ScreensList>
            <BuilderContainer bgColor={this.state.bgColor}>
              <StyledForm id="screen-details" onSubmit={this.saveScreen}>
                <Row>
                  <InputWrapper cols={2}>
                    <p>Section Name*</p>
                    <input
                      onChange={this.changeScreenName}
                      className="custom-textfield lb-textfield"
                      type="text"
                      name="section-name"
                      data-arg="sectionname"
                      placeholder={
                        currentScreen !== null
                          ? currentScreen.Title
                          : "New Screen"
                      }
                      // value = {currentScreen !== null ? currentScreen.Title : "New Screen"}
                    />
                  </InputWrapper>
                  <InputWrapper cols={2}>
                    <p>Screen Type*</p>
                    <select
                      className="custom-select lb-select"
                      onChange={this.chooseScreenType}
                      name="screentype"
                      data-arg="screentype"
                      // required={true}
                    >
                      <option
                        value={0}
                        selected={
                          currentScreen !== null &&
                          currentScreen.ScreenType === 0
                        }
                      >
                        Content
                      </option>
                      <option
                        value={1}
                        selected={
                          currentScreen !== null &&
                          currentScreen.ScreenType === 1
                        }
                      >
                        Interaction
                      </option>
                      <option
                        value={2}
                        selected={
                          currentScreen !== null &&
                          currentScreen.ScreenType === 2
                        }
                      >
                        Video
                      </option>
                      <option
                        value={4}
                        selected={
                          currentScreen !== null &&
                          currentScreen.ScreenType === 4
                        }
                      >
                        Vimeo
                      </option>
                    </select>
                  </InputWrapper>
                </Row>
                <Row>
                  <InputWrapper cols={2}>
                    <p>Next Button Label*</p>
                    <input
                      className="custom-textfield lb-textfield"
                      type="text"
                      name="next-button"
                      data-arg="nextbutton"
                      onChange={this.changeNextButtonText}
                      placeholder="Next Button Text"
                    />
                  </InputWrapper>
                  <InputWrapper cols={2}>
                    <p>Color*</p>
                    <StyledSelect
                      // className='custom-select'
                      onChange={this.changeColorHandler}
                      name="bgcolor"
                      data-arg="bgcolor"
                      // required={true}
                    >
                      {allColors.map((color) => (
                        <StyledOption
                          color={color[1].base}
                          key={color[0]}
                          value={color[1].base}
                        >
                          {color[0]}
                        </StyledOption>
                      ))}
                    </StyledSelect>
                  </InputWrapper>
                </Row>
                <Button type="submit">SAVE SCREEN</Button>
              </StyledForm>

              {this.showBuilder(newScreenType, currentScreen)}
            </BuilderContainer>
          </Container>
          <FabButton
            bgColor={`${this.state.bgColor}`}
            onClick={this.saveScreen}
          >
            <i className="fa fa-floppy-o" style={{ fontSize: "30px" }} />
          </FabButton>
        </Body>
      </div>
    );
  }
}

export default withServices(LessonBuilder);



// WEBPACK FOOTER //
// ./src/pages/Admin/LessonBuilder/LessonBuilder.Component.jsx